export default __webpack_public_path__ + "static/media/Purchase.e8aff30a.svg";